/* eslint-disable prettier/prettier */
import axios from 'axios'
import store from '../store'
import router from '../router/index'


const verifyUser = async function (authToken) {
    const baseURL = process.env.VUE_APP_AUTH_URL
    const url = '/api/v1/auth/verify'
    const headers = {
        'auth-token': authToken,
        'api-token': process.env.VUE_APP_API_TOKEN
    }
    return axios({
        method: 'GET',
        baseURL,
        url,
        headers
    })
        .then((response) => response)
        .catch(() => {
            store.reset()
            router.push({ name: 'Login' })
        })
}

export default verifyUser
